// Module
var code = "<label class=\"theme-settings-bg-item\"> <input type=\"radio\"> <span class=\"theme-settings-bg-name\"></span> </label> ";
// Exports
module.exports = code;